






















import vue from "vue";
import { VUEX_EXERCISE_GETTER_NAMES, VUEX_EXERCISE_NAMESPACE } from "@tt-app/constants";

import AssignmentCompletionModal from "@tt-app/components/assignment/AssignmentCompletionModal.vue";
import ExerciseHeader from "@tt-app/components/exerciseBase/ExerciseHeader.vue";
import ExerciseFooter from "@tt-app/components/exerciseBase/ExerciseFooter.vue";
import ExerciseNavigationModal from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseNavigationModal.vue";
import FeedbackPopup from "@tt-app/components/feedback/FeedbackPopup.vue";

const { ASSIGNMENTS_SUBMITTED, LOG_ID, REVIEW_PAGE } = VUEX_EXERCISE_GETTER_NAMES;

interface Computed {
  assignmentsSubmitted: number;
  exerciseLoading: boolean;
  feedbackPopupVisible: boolean;
  isReview: boolean;
  logId: string;
}

export default vue.extend<any, any, Computed, any>({
  name: "ExerciseLayout",

  components: {
    AssignmentCompletionModal,
    ExerciseNavigationModal,
    ExerciseFooter,
    ExerciseHeader,
    FeedbackPopup
  },

  data() {
    return {
      popups: {
        feedback: {
          visible: true
        }
      }
    };
  },

  methods: {
    handleFeedbackClose() {
      this.popups.feedback.visible = false;
    }
  },

  computed: {
    assignmentsSubmitted() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${ASSIGNMENTS_SUBMITTED}`];
    },

    exerciseLoading() {
      return this.$store.state.exercise.loading > 0;
    },

    feedbackPopupVisible() {
      return this.popups.feedback.visible && this.isReview;
    },

    isReview() {
      return Boolean(this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${REVIEW_PAGE}`]);
    },

    logId() {
      const logId = this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${LOG_ID}`];

      return String(logId);
    }
  }
});
